import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { NgDatepickerModule } from 'ng2-datepicker';
import { HttpClientModule } from '@angular/common/http'
import { AppRoutingModule } from './app-routing.module';
import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, } from 'ngx-ui-loader';
import { AgmCoreModule } from '@agm/core'
import { MyDatePickerTHModule } from 'mydatepicker-th'
import { MyDatePickerModule } from 'mydatepicker';
import { ExportAsModule } from 'ngx-export-as';
import { ChartsModule } from 'ng2-charts';
import { ChartModule } from 'angular-highcharts';
import { TextMaskModule } from 'angular2-text-mask';
import { DpDatePickerModule } from 'ng2-date-picker';
import * as $ from 'jquery';


// fullcalendar
import { FullCalendarModule } from '@fullcalendar/angular';
import { NumberDirective } from './numbers-only.directive';

// services
import { FundListService } from './services/fund-list.service';
import { PerformanceInvestmentService } from './services/performance-investment.service';
import { PerformanceCalculationService } from './services/performance-calculation.service';
import { FundService } from './services/fund.service';
import { NewsService } from './services/news.service';
import { DateService } from './services/date.service'
import { TestSerService } from './services/test-ser.service';


// components
import { AppComponent } from './app.component';

import { HeaderComponent } from './component/header/header.component';
import { FooterComponent } from './component/footer/footer.component';
import { ButtonComponent } from './component/button/button.component';
import { MainPageComponent } from './page/main-page/main-page.component';
import { InvestingPlanComponent } from './page/investing-plan/investing-plan.component';
import { PageHeaderComponent } from './component/page-header/page-header.component';
import { ProvidentFundComponent } from './page/provident-fund/provident-fund.component';
import { PrivateFundComponent } from './page/private-fund/private-fund.component';
import { FundServiceUnitComponent } from './page/fund-service-unit/fund-service-unit.component';
import { ContactUsComponent } from './page/contact-us/contact-us.component';
import { FundComponent } from './page/fund/fund.component';
import { CurveComponent } from './component/curve/curve.component';
import { CollapseCardComponent } from './component/collapse-card/collapse-card.component';
import { CollapseAccordionComponent } from './component/collapse-accordion/collapse-accordion.component';
import { IconButtonComponent } from './component/icon-button/icon-button.component';
import { SwiperComponent } from './component/swiper/swiper.component';
import { FundListComponent } from './feature/fund-list/fund-list.component';
import { FavoriteButtonComponent } from './component/favorite-button/favorite-button.component';
import { FundListItemComponent } from './feature/fund-list-item/fund-list-item.component';
import { DownloadFormComponent } from './page/download-form/download-form.component';
import { PaginatorComponent } from './component/paginator/paginator.component';
import { ComplianceGoodGovernenceComponent } from './page/compliance-good-governence/compliance-good-governence.component';
import { DropdownComponent } from './component/dropdown/dropdown.component';
import { ComplianceIndexManagerComponent } from './page';
import { FundRiskComponent } from './feature/fund-risk/fund-risk.component';
import { NavMenuComponent } from './component/nav-menu/nav-menu.component';
import { BigRadioComponent } from './component/big-radio/big-radio.component';
import { DownloadListItemComponent } from './component/download-list-item/download-list-item.component';
import { SelectComponent } from './component/select/select.component';
import { InputComponent } from './component/input/input.component';
import { CardComponent } from './component/card/card.component';
import { NewsComponent } from './page/news/news.component';
import { MarketConditionsComponent } from './page/market-conditions/market-conditions.component';
import { InvestingByRiskComponent } from './feature/investing-by-risk/investing-by-risk.component';
import { RadioComponent } from './component/radio/radio.component';
import { CheckboxComponent } from './component/checkbox/checkbox.component';
import { RadioSliderComponent } from './component/radio-slider/radio-slider.component';
import { DatepickerComponent } from './component/datepicker/datepicker.component';
import { PerformanceReportComponent } from './feature/performance-report/performance-report.component';
import { FundCardComponent } from './component/fund-card/fund-card.component';
import { NewsDetailComponent } from './page/news-detail/news-detail.component';
import { SafePipe } from './pipe/safe.pipe';
import { FundDatailComponent } from './page/fund-datail/fund-datail.component';
import { AnnounceDetailComponent } from './page/announce-detail/announce-detail.component';
import { EartupdateDetailComponent } from './page/eartupdate-detail/eartupdate-detail.component';
import { PromotionDetailComponent } from './page/promotion-detail/promotion-detail.component';
import { PromotionComponent } from './page/promotion/promotion.component';
import { BenefitDetailComponent } from './page/benefit-detail/benefit-detail.component';
import { CalculateStep2Component } from './page/calculate-step2/calculate-step2.component';
import { CalculateResultComponent } from './page/calculate-result/calculate-result.component';
import { CalculateStep3Component } from './page/calculate-step3/calculate-step3.component'
import { FundrecommComponent } from './page/fundrecomm/fundrecomm.component';
import { FundrecommDetailComponent } from './page/fundrecomm-detail/fundrecomm-detail.component';
import { FundCompareComponent } from './page/fund-compare/fund-compare.component';
import { FundCompareResultComponent } from './page/fund-compare-result/fund-compare-result.component';
import { MarketDetailComponent } from './page/market-detail/market-detail.component';
import { GoodgovernenceDetailComponent } from './page/goodgovernence-detail/goodgovernence-detail.component';
import { EthicDetailComponent } from './page/ethic-detail/ethic-detail.component';
import { CorruptionDetailComponent } from './page/corruption-detail/corruption-detail.component';
import { ProductDetailComponent } from './page/product-detail/product-detail.component';
import { ManagerDetailComponent } from './page/manager-detail/manager-detail.component';
import { TransactionDetailComponent } from './page/transaction-detail/transaction-detail.component';
import { GuidelineDetailComponent } from './page/guideline-detail/guideline-detail.component';
import { VoteDetailComponent } from './page/vote-detail/vote-detail.component';
import { HoldingInvestUnitDetailComponent } from './page/holding-invest-unit-detail/holding-invest-unit-detail.component';
import { TestComponent } from './page/test/test.component';
import { VdoDetailComponent } from './page/vdo-detail/vdo-detail.component';
import { NewsletterDetailComponent } from './page/newsletter-detail/newsletter-detail.component';
import { YoutubePlayerModule } from 'ngx-youtube-player';
import { FavoriteComponent } from './page/favorite/favorite.component';
import { FundDetailUsdComponent } from './page/fund-detail-usd/fund-detail-usd.component';
import { AboutUsComponent } from './component/about-us/about-us.component';
import { EllipsisPipe } from './pipe/ellipsis.pipe';
import { FaqPipe } from './pipe/faq.pipe';
import { CookieService } from 'ngx-cookie-service';
import { FaqComponent } from './page/faq/faq.component';
import { CalendarComponent } from './page/calendar/calendar.component';
import { PageHeaderPngComponent } from './component/page-header-png/page-header-png.component';
import { Sitemap2Component } from './page/sitemap/sitemap2.component';
import { JobListComponent } from './page/job-list/job-list.component';
import { JobDetailComponent } from './page/job-detail/job-detail.component';
import { JobApplyComponent } from './page/job-apply/job-apply.component';
import { PageHeaderJobComponent } from './component/page-header-job/page-header-job.component';
import { CollapseCardJobComponent } from './component/collapse-card-job/collapse-card-job.component';
import { JobTmpComponent } from './page/job-tmp/job-tmp.component';
import { SearchComponent } from './component/search/search.component';
import { RadioClientReportComponent } from './component/radio-client-report/radio-client-report.component';
// search module
import { FilterPipeModule } from 'ngx-filter-pipe';
import { ButtonJobComponent } from './component/button-job/button-job.component';
import { JobApplyEducationComponent } from './page/job-apply-education/job-apply-education.component';
import { JobApplyFamilyComponent } from './page/job-apply-family/job-apply-family.component';
import { JobApplyExperienceComponent } from './page/job-apply-experience/job-apply-experience.component';
import { JobConfirmComponent } from './page/job-confirm/job-confirm.component';
import { ButtonDeleteJobComponent } from './component/button-delete-job/button-delete-job.component';
import { InvestingLearningComponent } from './page/investing-learning/investing-learning.component';
import { LearningDetailComponent } from './page/learning-detail/learning-detail.component';
import { FormatPdfSaveComponent } from './component/format-pdf-save/format-pdf-save.component';
import { CollapseJobComponent } from './component/collapse-job/collapse-job.component';
import { PrivacyPolicyComponent } from './page/privace-polilcy/privace-polilcy.component';
import { ClientReportComponent } from './page/client-report/client-report.component';
import { AssignedPersonnelDetailComponent } from './page/assigned-personnel-detail/assigned-personnel-detail.component';
import { OneamPrivacyNoticeComponent } from './page/oneam-privacy-notice/oneam-privacy-notice.component';
import { TaxConsentComponent } from './page/tax-consent/tax-consent.component';
import { OneamIndexLevelComponent } from './page/oneam-index-level/oneam-index-level.component';
import {AssetProfileComponent} from './page/asset-profile/asset-profile.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#FFAF3E',
  fgsPosition: 'center-center',
  fgsSize: 140,
  fgsType: SPINNER.fadingCircle,
  hasProgressBar: false,

};


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ButtonComponent,
    MainPageComponent,
    InvestingPlanComponent,
    PageHeaderComponent,
    ProvidentFundComponent,
    PrivateFundComponent,
    FundServiceUnitComponent,
    ContactUsComponent,
    FundComponent,
    CurveComponent,
    CollapseCardComponent,
    CollapseAccordionComponent,
    IconButtonComponent,
    SwiperComponent,
    FundListComponent,
    FavoriteButtonComponent,
    FundListItemComponent,
    DownloadFormComponent,
    PaginatorComponent,
    ComplianceGoodGovernenceComponent,
    ComplianceIndexManagerComponent,
    DropdownComponent,
    FundRiskComponent,
    NavMenuComponent,
    BigRadioComponent,
    DownloadListItemComponent,
    SelectComponent,
    InputComponent,
    CardComponent,
    NewsComponent,
    InvestingByRiskComponent,
    RadioComponent,
    CheckboxComponent,
    MarketConditionsComponent,
    RadioSliderComponent,
    DatepickerComponent,
    PerformanceReportComponent,
    FundCardComponent,
    NewsDetailComponent,
    SafePipe,
    FundDatailComponent,
    AnnounceDetailComponent,
    EartupdateDetailComponent,
    PromotionDetailComponent,
    PromotionComponent,
    BenefitDetailComponent,
    CalculateStep2Component,
    CalculateResultComponent,
    CalculateStep3Component,
    FundrecommComponent,
    FundrecommDetailComponent,
    FundCompareComponent,
    FundCompareResultComponent,
    MarketDetailComponent,
    GoodgovernenceDetailComponent,
    EthicDetailComponent,
    CorruptionDetailComponent,
    ProductDetailComponent,
    ManagerDetailComponent,
    TransactionDetailComponent,
    GuidelineDetailComponent,
    VoteDetailComponent,
    HoldingInvestUnitDetailComponent,
    TestComponent,
    VdoDetailComponent,
    NewsletterDetailComponent,
    FavoriteComponent,
    FundDetailUsdComponent,
    AboutUsComponent,
    EllipsisPipe,
    FaqPipe,
    FaqComponent,
    CalendarComponent,
    PageHeaderPngComponent,
    Sitemap2Component,
    JobListComponent,
    JobDetailComponent,
    JobApplyComponent,
    PageHeaderJobComponent,
    CollapseCardJobComponent,
    JobTmpComponent,
    SearchComponent,
    ButtonJobComponent,
    JobApplyEducationComponent,
    JobApplyFamilyComponent,
    JobApplyExperienceComponent,
    JobConfirmComponent,
    ButtonDeleteJobComponent,
    NumberDirective,
    InvestingLearningComponent,
    LearningDetailComponent,
    FormatPdfSaveComponent,
    CollapseJobComponent,
    PrivacyPolicyComponent,
    ClientReportComponent,
    RadioClientReportComponent,
    AssignedPersonnelDetailComponent,
    OneamPrivacyNoticeComponent,
    TaxConsentComponent,
    OneamIndexLevelComponent,
    AssetProfileComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgDatepickerModule,
    DpDatePickerModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAlhGg_uzntbY1-eB9ZByJqD-k04iV01nI',
      libraries: ['places']
    }),
    MyDatePickerTHModule,
    MyDatePickerModule,
    ChartsModule,
    ChartModule,
    YoutubePlayerModule,
    ExportAsModule,
    TextMaskModule,
    FullCalendarModule,
    FilterPipeModule
  ],
  providers: [
    FundListService,
    PerformanceInvestmentService,
    PerformanceCalculationService,
    FundService,
    NewsService,
    DateService,
    TestSerService,
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
